<pdq-card color="white" variant="popover">
  @if (loading) {
    <!-- Empty white space while loading -->
  } @else if (rows.length > 0) {
    @for (row of rows; track row.cart.id) {
      <div class="list-row">
        <div class="list-row__info">
          <div class="list-row__title">{{ row.cart.name || 'Untitled' }}</div>
          @if (row.cart.description) {
            <span class="body-12-regular text-secondary">{{ row.cart.description }}</span>
          }
        </div>

        <div class="list-row__actions">
          @if (row.cart.id === duplicatingId) {
            <pdq-spinner [small]="true"></pdq-spinner>
          } @else {
            <feature-mode-picker
              tagSize="small"
              tagMode="rect"
              [hideTestMode]="true"
              [control]="row.stateControl"></feature-mode-picker>
            <pdq-button
              pdqPopover
              variant="ghost"
              icon="dots_menu"
              [popoverTemplate]="actions"
              [forcePosition]="'bottom'"
              [closeOnPopoverClick]="true"
              [closeOnClickOutside]="true">
            </pdq-button>
            <ng-template #actions>
              <pdq-popover-container [loading]="false" [actionList]="true">
                <div class="action-list">
                  @for (option of actionOptions; track option.value) {
                    @if (option.value === Actions.DELETE && row.cart.isLive) {
                      <pdq-option [disabled]="true">
                        <div class="action-list__delete-disabled">
                          <span>{{ option.label }}</span>
                          <span class="action-list__delete-disabled-hint">Must be disabled to delete</span>
                        </div>
                      </pdq-option>
                    } @else {
                      <pdq-option (onSelect)="onActionOptionSelect(option.value, row.cart.id)">
                        {{ option.label }}
                      </pdq-option>
                    }
                  }
                </div>
              </pdq-popover-container>
            </ng-template>
          }
        </div>
      </div>
    }
  }
</pdq-card>
